/**
 * Copyright 2017-present Palantir Technologies
 * @license MIT
 */
"use strict";
/**
 * Polyfill for Object.assign
 */
function assign() {
    var objs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objs[_i] = arguments[_i];
    }
    var result = {};
    for (var _a = 0, objs_1 = objs; _a < objs_1.length; _a++) {
        var obj = objs_1[_a];
        var keys = Object.keys(obj);
        for (var _b = 0, keys_1 = keys; _b < keys_1.length; _b++) {
            var key = keys_1[_b];
            result[key] = obj[key];
        }
    }
    return result;
}
exports.assign = assign;



//////////////////
// WEBPACK FOOTER
// ./~/plottable/build/src/utils/objectUtils.js
// module id = 1010
// module chunks = 0